import React, { useEffect, useState } from 'react';
import { Box, Skeleton, Typography } from '@mui/material';
import qrCode from '@images/wallet/qr-code.jpg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { paymentDate } from '../../apis/payment';
import { privateRoutes } from '../../configs/routes';
import Error from '../../components/Error';
import commafy from '../../utils/commafyHelper';
import './receipt.scss';

function SkeletonBox() {
  return (
    <Skeleton variant='rectangular' width='40%' height='24px' sx={{ borderRadius: '0.5rem' }} />
  );
}
const Receipt = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const id = searchParams?.get('id');
  const [receiptData, setReceiptData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  const { transactionDate, type, status, amount, paymentCode } = receiptData || {};

  const getReceiptData = () => {
    setLoading(true);
    if (error) setError(false);
    paymentDate(id)
      .then((res) => setReceiptData(res))
      .catch(() => setError(true))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (id) getReceiptData();
    else navigate(privateRoutes.dashboard);
  }, [id]);

  if (error) return <Error onRetry={() => getReceiptData()} fullHeight />;

  return (
    <Box className='mainContainer'>
      <Box className='styledReceipt'>
        <hr className='hr' />

        <Typography className='titleReceipt'>رسید تراکنش</Typography>

        <hr className='hr' />

        <Box className='rowReceipt'>
          <Typography color='text.light'>تاریخ تراکنش:</Typography>
          {loading ? (
            <SkeletonBox />
          ) : (
            <Typography color='text.main' sx={{ direction: 'ltr' }}>
              {transactionDate}
            </Typography>
          )}
        </Box>

        <Box className='rowReceipt'>
          <Typography color='text.light'>نوع تراکنش:</Typography>
          {loading ? (
            <SkeletonBox />
          ) : (
            <Typography color='text.main'>{type === 1 ? 'شارژ کیف پول' : '---'}</Typography>
          )}
        </Box>

        <Box className='rowReceipt'>
          <Typography color='text.light'>وضعیت:</Typography>
          {loading ? (
            <SkeletonBox />
          ) : (
            <Typography color={status === 1 ? 'success.main' : 'error.main'}>
              {status === 1 ? 'موفق' : 'ناموفق'}
            </Typography>
          )}
        </Box>

        <hr className='hr' />

        <Box className='rowReceipt'>
          <Typography color='text.light'>مبلغ:</Typography>
          {loading ? (
            <SkeletonBox />
          ) : (
            <Typography color='text.main'>
              {commafy(amount)}
              <span className='unit'>تومان</span>
            </Typography>
          )}
        </Box>

        <Box className='rowReceipt'>
          <Typography color='text.light'>شماره پیگیری:</Typography>
          {loading ? <SkeletonBox /> : <Typography color='text.main'>{paymentCode}</Typography>}
        </Box>

        {loading ? (
          <Skeleton
            variant='rectangular'
            width='98%'
            height='34px'
            sx={{ borderRadius: '0.5rem' }}
          />
        ) : (
          <img src={qrCode} alt='' width={192} height={50} />
        )}
      </Box>
    </Box>
  );
};

export default Receipt;
